"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var INITIALOPTIONS = exports.INITIALOPTIONS = {
    zoom: 14,
    disableDefaultUI: true,
    zoomControl: false,
    mapTypeControl: false
};